import { Loading } from '@/components/loading/Loading';
import { FC, Suspense } from 'react';
import { CustomerCatalogueContainer } from '../CustomerCatalogueContainer';
import { CustomerCatalogue } from './CustomerCatalogue';

export const CustomerCataloguePage: FC = () => {
  return (
    <CustomerCatalogueContainer>
      <div className="flex w-full">
        <Suspense fallback={<Loading className="h-screen" />}>
          <CustomerCatalogue />
        </Suspense>
      </div>
    </CustomerCatalogueContainer>
  );
};
